var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 222,
    viewBox: "0 0 225 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.125 167.064C100.596 180.41 88.601 208.719 77.493 208.243C62.3844 207.591 64.3673 190.52 62.4348 189.053C60.5023 187.585 48.8281 199.942 39.3448 191.505C29.0501 182.351 38.4994 171.045 37.3172 168.058C36.135 165.07 20.6482 167.798 17.9089 153.512C16.0504 143.884 23.778 138.743 31.0847 136.156C33.335 135.129 28.4828 135.064 23.0902 129.508C15.9606 122.171 19.3056 108.543 35.7239 106.952C52.1422 105.362 74.2942 110.163 80.5173 107.478C86.7405 104.793 188.644 35.2401 223.386 11.9337L268.559 90.1765C268.559 90.1765 119.666 156.253 111.125 167.064Z",
    fill: "#F2AE72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4809 152.806C62.3906 138.793 74.6122 126.657 81.4152 129.532C88.2182 132.406 82.6619 137.787 85.9598 143.499C89.2576 149.211 96.8288 147.289 95.2926 154.978C93.7564 162.667 77.8585 165.585 70.4809 152.806Z",
    fill: "#FFF6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7642 185.309C86.2555 187.396 87.8514 175.788 84.0438 174.418C80.2363 173.049 75.7606 183.408 80.7642 185.309Z",
    fill: "#FFF6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0257 173.797C60.9634 176.004 68.0635 167.577 65.1555 164.921C62.6467 162.631 53.3659 170.3 58.0257 173.797Z",
    fill: "#FFF6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.738 149.373C45.8318 154.476 58.1621 152.113 57.3178 147.525C56.4734 142.936 43.4569 143.402 44.738 149.373Z",
    fill: "#FFF6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0645 125.415C45.4033 130.033 56.8287 131.892 57.4585 127.357C58.0884 122.822 46.8544 119.879 46.0645 125.415Z",
    fill: "#FFF6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.367 55.8968C190.502 45.8568 187.72 61.6742 200.542 54.8016C213.365 47.929 217.065 67.4746 228.056 63.062C234.038 60.6618 243.534 61.8542 249.53 57.2041L223.412 11.966C209.218 21.4507 183.85 38.6697 158.367 55.8968Z",
    fill: "#D48648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.88 96.5217C176.269 105.199 165.689 99.0656 150.364 100.312C135.038 101.559 148.664 123.055 141.735 131.685C136.192 138.591 143.016 139.917 142.208 149.031C160.908 139.601 185.265 128.122 207.601 117.817C206.939 104.26 194.013 89.1953 185.88 96.5217Z",
    fill: "#D48648"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 250,
    fill: "white",
    transform: "translate(56 222) rotate(-120)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryRight);
export default __webpack_public_path__ + "static/media/gallery-right.62e71213e588b0c48be1ec8e3911e877.svg";
export { ForwardRef as ReactComponent };